import Debug from 'debug';
import { inject, injectable } from 'inversify';
import { QueryHandler } from '@/app/tracking/common';
import { QueryExamResultsTrackingQuery, QueryExamResultsTrackingQueryPayload } from '../api'
import { ExamSuspendDataStore } from '../common';

const debug = Debug('scorm2004-query-exam-results-query-handler')

@injectable()
export class Scorm2004QueryExamResultsQueryHandler implements QueryHandler<QueryExamResultsTrackingQuery> {

  constructor (
    @inject(ExamSuspendDataStore)
    private examStore: ExamSuspendDataStore,
  ) {}
  
  public async execute(query: QueryExamResultsTrackingQueryPayload) {

    debug('execute', query)

    const exams = await this.examStore.query('all')

    debug('exams', exams)

    return {
      exams
    }
  }
}
